module.exports = __webpack_public_path__ + "media/alaska/forrest-3843b1eb.jpg";